
import React from 'react'

const Sizes = {
    'small': {
        width: '40px',
        height: '40px'
    },
    'default': {
        width: '80px',
        height: '80px'
    },
    'large': {
        width: '200px',
        height: '200px'

    }
}
const PreLoader = (props) => {
    const { spinning = true, size = 'default', children, className, loadingClassName, fullHeight } = props;
    const DefaultLoader = (<svg style={{ 'background': 'none' }} width={`${Sizes[size].width}`} height={`${Sizes[size].height}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" className="lds-eclipse" ><path ng-attr-d="{{config.pathCmd}}" ng-attr-fill="{{config.color}}" stroke="none" d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50" transform="rotate(257.03 50 51)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 51;360 50 51" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite" /></path></svg>);
    const { loader = DefaultLoader } = props;
    const classProp = spinning ? { className: `tb--preloader-container ${loadingClassName ? loadingClassName : ''}` } : (className ? { className } : {})
    return <div {...classProp} style={fullHeight ? {height: '100%'} : {}}>{children} {spinning ? loader : ''} </div>
}

export default PreLoader;